module.exports = "/_next/static/images/gl-73ae82a7002c8f6c7319b90b47e059d9.svg";